const auth = {}
export default auth
